"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useSnowplowListener_1 = __importDefault(require("./useSnowplowListener"));
const usePageViewListener_1 = __importDefault(require("./usePageViewListener"));
const browser_tracker_1 = require("@snowplow/browser-tracker");
const snowplow_js_common_1 = require("@angi/snowplow-js-common");
const useComponentDisplay = (enable, componentType, additionalEntities = []) => {
    if (!enable) {
        return;
    }
    const snowplow = (0, useSnowplowListener_1.default)();
    const pageViewReady = (0, usePageViewListener_1.default)();
    (0, react_1.useEffect)(() => {
        const data = {
            component_type: componentType,
        };
        if (snowplow !== undefined && pageViewReady) {
            (0, browser_tracker_1.trackSelfDescribingEvent)({
                event: (0, snowplow_js_common_1.componentDisplayEvent)(),
                context: [(0, snowplow_js_common_1.componentAttributesContext)(data), ...additionalEntities],
            });
        }
    }, [snowplow, pageViewReady]);
};
exports.default = useComponentDisplay;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlQ29tcG9uZW50RGlzcGxheS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VDb21wb25lbnREaXNwbGF5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsaUNBQWtDO0FBQ2xDLGdGQUF3RDtBQUN4RCxnRkFBd0Q7QUFDeEQsK0RBQXFFO0FBRXJFLGlFQUE2RjtBQUU3RixNQUFNLG1CQUFtQixHQUFHLENBQ3hCLE1BQWUsRUFDZixhQUFxQixFQUNyQixxQkFBMkMsRUFBRSxFQUN6QyxFQUFFO0lBQ04sSUFBSSxDQUFDLE1BQU0sRUFBRTtRQUNULE9BQU87S0FDVjtJQUVELE1BQU0sUUFBUSxHQUFHLElBQUEsNkJBQW1CLEdBQUUsQ0FBQztJQUN2QyxNQUFNLGFBQWEsR0FBRyxJQUFBLDZCQUFtQixHQUFFLENBQUM7SUFFNUMsSUFBQSxpQkFBUyxFQUFDLEdBQUcsRUFBRTtRQUNYLE1BQU0sSUFBSSxHQUFHO1lBQ1QsY0FBYyxFQUFFLGFBQWE7U0FDaEMsQ0FBQztRQUVGLElBQUksUUFBUSxLQUFLLFNBQVMsSUFBSSxhQUFhLEVBQUU7WUFDekMsSUFBQSwwQ0FBd0IsRUFBQztnQkFDckIsS0FBSyxFQUFFLElBQUEsMENBQXFCLEdBQUU7Z0JBQzlCLE9BQU8sRUFBRSxDQUFDLElBQUEsK0NBQTBCLEVBQUMsSUFBSSxDQUFDLEVBQUUsR0FBRyxrQkFBa0IsQ0FBQzthQUNyRSxDQUFDLENBQUM7U0FDTjtJQUNMLENBQUMsRUFBRSxDQUFDLFFBQVEsRUFBRSxhQUFhLENBQUMsQ0FBQyxDQUFDO0FBQ2xDLENBQUMsQ0FBQztBQUVGLGtCQUFlLG1CQUFtQixDQUFDIn0=


// WEBPACK FOOTER //
// ../../../../src/react/hooks/useComponentDisplay.ts